<rask-header [uppercase]="true">
  Hantera verksamhetsområden
</rask-header>
<rask-container-block>
  <ng-container header>Shape-fil</ng-container>
  <div class="row mt-2">
    <div class="col">
      <rask-button aid="buttonUploader" color="primary" icon="fas fa-upload" (click)="uploader.click()">Applicera
      shapefil</rask-button>
      <input hidden type="file" #uploader (change)="uploadFile($any($event.target).files, false)"
        accept="file/*.zip" />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <rask-button aid="migrateBtn" color="primary" (click)="migrateJokkmokkToBoden()">Migrera Jokkmokk =>
        Boden</rask-button>
      </div>
    </div>
    @if (infoClass) {
      <div class="p-3 mt-2" [ngClass]="infoClass">
        <div class="row">
          <pre>{{ message }}</pre>
        </div>
      </div>
    }
  </rask-container-block>